import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * Created by AAravindan on 5/4/16.
 */
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { EMA } from "./EMA";
import { SMA } from "./SMA";
export var MACDInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(MACDInput, _IndicatorInput);

  function MACDInput(values) {
    var _this;

    _classCallCheck(this, MACDInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MACDInput).call(this));
    _this.values = values;
    _this.SimpleMAOscillator = true;
    _this.SimpleMASignal = true;
    return _this;
  }

  return MACDInput;
}(IndicatorInput);
export var MACDOutput = function MACDOutput() {
  _classCallCheck(this, MACDOutput);
};
export var MACD =
/*#__PURE__*/
function (_Indicator) {
  _inherits(MACD, _Indicator);

  function MACD(input) {
    var _this2;

    _classCallCheck(this, MACD);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MACD).call(this, input));
    var oscillatorMAtype = input.SimpleMAOscillator ? SMA : EMA;
    var signalMAtype = input.SimpleMASignal ? SMA : EMA;
    var fastMAProducer = new oscillatorMAtype({
      period: input.fastPeriod,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var slowMAProducer = new oscillatorMAtype({
      period: input.slowPeriod,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var signalMAProducer = new signalMAtype({
      period: input.signalPeriod,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var format = _this2.format;
    _this2.result = [];
    _this2.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var index, tick, MACD, signal, histogram, fast, slow;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              index = 0;

            case 1:
              if (!true) {
                _context.next = 19;
                break;
              }

              if (!(index < input.slowPeriod)) {
                _context.next = 10;
                break;
              }

              _context.next = 5;
              return;

            case 5:
              tick = _context.sent;
              fast = fastMAProducer.nextValue(tick);
              slow = slowMAProducer.nextValue(tick);
              index++;
              return _context.abrupt("continue", 1);

            case 10:
              if (fast && slow) {
                MACD = fast - slow;
                signal = signalMAProducer.nextValue(MACD);
              }

              histogram = MACD - signal;
              _context.next = 14;
              return {
                // fast : fast,
                // slow : slow,
                MACD: format(MACD),
                signal: signal ? format(signal) : undefined,
                histogram: isNaN(histogram) ? undefined : format(histogram)
              };

            case 14:
              tick = _context.sent;
              fast = fastMAProducer.nextValue(tick);
              slow = slowMAProducer.nextValue(tick);
              _context.next = 1;
              break;

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this2.generator.next();

    input.values.forEach(function (tick) {
      var result = _this2.generator.next(tick);

      if (result.value !== undefined) {
        _this2.result.push(result.value);
      }
    });
    return _this2;
  }

  _createClass(MACD, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;
      return result;
    }
  }]);

  return MACD;
}(Indicator);
MACD.calculate = macd;
export function macd(input) {
  Indicator.reverseInputs(input);
  var result = new MACD(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}